import PurchaseHistoryPageState from "@GeriMed/Store/Pages/PurchaseHistory/PurchaseHistoryState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";

const initialState: PurchaseHistoryPageState = {
    getPurchaseHistoryParameter: {
        customerNumber: "",
    }
};
const reducer = {};

const purchaseHistoryPageReducer = createTypedReducerWithImmer(initialState,reducer);

(reducers as any).purchaseHistoryPageState = purchaseHistoryPageReducer;
